import React from 'react';
import Banner from '../Bannner/Banner';
import Details from '../Details/Details';

const Medicine = () => {
    return (
        <>
            <Banner />
            <Details />
        </>
    );
};

export default Medicine;